import React, { useState } from 'react';
import { Space, Typography, Badge, Tooltip, Button } from 'antd';
import { 
  TeamOutlined,
  LogoutOutlined,
  SwapOutlined
} from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';
import OrganizationSelectModal from './OrganizationSelectModal';
import { getString } from '../utils/translations';

const { Text } = Typography;

const OrganizationHeader = () => {
  const [selectorOpen, setSelectorOpen] = useState(false);
  const { 
    user, 
    organization, 
    organizations,
    signOut
  } = useAuth();

  if (!user || !organization) {
    return null;
  }

  return (
    <>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '8px 16px',
        background: '#f0f2f5',
        borderBottom: '1px solid #d9d9d9'
      }}>
        {/* Organization Info */}
        <Space>
          <TeamOutlined style={{ color: '#1890ff' }} />
          <Text strong>{organization.name}</Text>
          <Badge 
            status={organization.videoProcessingEnabled ? "success" : "warning"} 
            text={organization.videoProcessingEnabled ? "Active" : "Inactive"}
          />
        </Space>

        {/* Actions */}
        <Space>
          <Text type="secondary" style={{ fontSize: 12 }}>
            {user.email}
          </Text>

          {(organizations || []).length > 1 && (
            <Tooltip title={getString('pipeline.auth.change_organization', 'Change Organization')}>
              <Button
                type="text"
                icon={<SwapOutlined />}
                onClick={() => setSelectorOpen(true)}
              >
                {getString('pipeline.auth.change_organization', 'Change Organization')}
              </Button>
            </Tooltip>
          )}
          
          <Tooltip title={getString('pipeline.nav.sign_out', 'Sign Out')}>
            <Button 
              type="text" 
              icon={<LogoutOutlined />}
              onClick={signOut}
              danger
            >
              {getString('pipeline.nav.sign_out', 'Sign Out')}
            </Button>
          </Tooltip>
        </Space>
      </div>
      <OrganizationSelectModal
        open={selectorOpen}
        closable
        onClose={() => setSelectorOpen(false)}
      />
    </>
  );
};

export default OrganizationHeader;
